export default __webpack_public_path__ + "static/media/friend_jinro.d5c8f05c.png";